import React, { useState } from 'react';
import Modal from '../Modal';
import Button from '../Button';
import Alert from '../Alert';
import { enableEnterpriseClasses } from '../../api/admin';

/**
 * class-stream A4：「启用团队」弹窗。
 * 输入第 1 个团队名 + 展示「将把 N 个员工塞进此团队」→ 调 enable-classes。
 *
 * Props:
 *   entId          企业 id
 *   employeeCount  当前企业员工数（口径与后端 enable-classes 全员归班一致）
 *   onClose        关闭
 *   onDone         成功回调（父级据此刷新）
 */
export default function EnableClassesModal({ entId, employeeCount = 0, onClose, onDone }) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!name.trim()) { setError('请输入团队名称'); return; }
    setSaving(true); setError('');
    try {
      await enableEnterpriseClasses(entId, { first_class_name: name.trim() });
      onDone?.();
    } catch (e) {
      setError(e.response?.data?.detail || '启用团队失败');
      setSaving(false);
    }
  };

  return (
    <Modal
      open
      onClose={onClose}
      title="启用团队"
      maxWidth={460}
      footer={
        <>
          <Button variant="secondary" size="sm" onClick={onClose}>取消</Button>
          <Button size="sm" onClick={handleSubmit} loading={saving}>启用</Button>
        </>
      }
    >
      {error && <Alert type="error">{error}</Alert>}
      <Alert type="info">
        将把 {employeeCount} 个员工塞进此团队。启用后注册码改为带团队编号形态，新员工注册后将进入对应团队。
      </Alert>
      <div style={{ marginTop: 4 }}>
        <label style={labelStyle}>第一个团队名称</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="如：一班、研发部"
          style={inputStyle}
          autoFocus
        />
      </div>
    </Modal>
  );
}

const labelStyle = { fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 };
const inputStyle = { padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13, width: '100%', boxSizing: 'border-box' };
